import { Fragment, useEffect } from "react";
import useStyles from "./styles";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const PasswordChanged = ({ returnUrl,...props }: any) => {
  var classes = useStyles();

  useEffect(() => {

    setTimeout(() => {
      callback()
    }, 5000);
  }, [])


  const callback = () => {
    if (returnUrl.length > 0) {
      window.location.href = (returnUrl as string).split("=")[1];
  }
  }

  return (
    <Fragment>
        <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h2" variant="h5">
        Su contraseña ha sido cambiada de manera exitosa, será redirigido nuevamente al sistema.
      </Typography>
    </Fragment>
  );
};

export default PasswordChanged;
